import { render, staticRenderFns } from "./navLeftCulture.vue?vue&type=template&id=1d2301bc&scoped=true"
import script from "./navLeftCulture.vue?vue&type=script&lang=js"
export * from "./navLeftCulture.vue?vue&type=script&lang=js"
import style0 from "./navLeftCulture.vue?vue&type=style&index=0&id=1d2301bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2301bc",
  null
  
)

export default component.exports